import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MyCommissionsComponent } from './my-commissions.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared.module';
import { MyCommissionsDialogComponent } from './my-commissions-dialog.component';
import { AuxDialogModule } from './aux-dialog.module';


@NgModule({
  imports: [
    SharedModule,
    ReactiveFormsModule,
    RouterModule,
    AuxDialogModule
  ],
  declarations: [MyCommissionsComponent, MyCommissionsDialogComponent]
})
export class MyCommissionsModule {}
